import { type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './useAuth';
import type { Perfil } from './types';

interface RequireRoleProps {
  allow: Perfil | Perfil[];
  children: ReactNode;
}

/**
 * Restringe o sub-tree ao(s) perfil(is) permitido(s).
 * Caso o perfil corrente não esteja na lista, redireciona para a home do perfil:
 *   - ADMINISTRATIVO → `/`
 *   - COLABORADOR → `/me`
 *
 * Deve sempre ser usado dentro de `<RequireAuth>` (que garante `user != null`).
 */
export function RequireRole({ allow, children }: RequireRoleProps): JSX.Element {
  const { user } = useAuth();
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  const allowed = Array.isArray(allow) ? allow : [allow];
  if (!allowed.includes(user.perfil)) {
    const home = user.perfil === 'ADMINISTRATIVO' ? '/' : '/me';
    return <Navigate to={home} replace />;
  }
  return <>{children}</>;
}
